<template>
  <div>
    <TitleCard
      :titleMsg1="titleMsg1"
      :titleMsg2="titleMsg2"
      :titleMsg3="titleMsg3"
      :titleMsg4="titleMsg4"
    ></TitleCard>

    <a-card class="all-card-style">
      <a-form layout="inline">
        <a-form-item label="作物品种"  class="ant-form-item2 ">
          <a-select placeholder="请选择" @change="handleSelectChange">
            <a-select-option value="1">鲤鱼</a-select-option>
            <a-select-option value="2">草鱼</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="种植时间"  class="ant-form-item2 ">
          <a-select placeholder="请选择" @change="handleSelectChange">
            <a-select-option value="1">禁食</a-select-option>
            <a-select-option value="2">症状2</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="种植面积"  class="ant-form-item2 ">
          <a-input placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item label="柱距"  class="ant-form-item2 ">
          <a-input placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item label="行距"  class="ant-form-item2 ">
          <a-input placeholder="请输入"></a-input>
        </a-form-item>
      </a-form>
      <a-card>
        <a-form-item label="上传图片"  class="ant-form-item2 ">
          <a-upload
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            :before-upload="beforeUpload"
            @change="handleChange"
          >
            <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" style="color:#ffffff" />
              <div class="ant-upload-text" style="color:#ffffff">点击上传</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button
            type="primary"
            html-type="submit"
            @click="resultOnclick"
            style="margin-left:-111px"
          >分析</a-button>
        </a-form-item>
      </a-card>
    </a-card>

   <div class="dal-card">
      <a-card>
      <a-list>
        <a-list-item key="3"  style="color:#ffffff;line-height:25px;" v-show="dalResultVisible">
          <a-list-item-meta style="">
            <a slot="title" class="pfl-card-title"  style="color:#ffffff;margin-">诊断结果</a>
          </a-list-item-meta>

            水生生物的摄食可以使个体获得能量以维持自身的生存、生长和繁殖，其摄食生长受诸多内源和外源因素的影响。自然状态下受水温、溶解氧、pH、亚硝酸盐、氨态氮等外源因素和动物的食性、体内激素等内源因素的影响。人工养殖条件下，投喂策略是重要的外源影响因素

        </a-list-item>
      </a-list>
    </a-card>
   </div>
  </div>
</template>

<script>
import TitleCard from "@/components/TitleCard.vue";

export default {
  name: "diseaseAnalysisList",
  components: {
    TitleCard,
  },
  data() {
    return {
      titleMsg1: "农技服务",
      titleMsg2: "病害虫管理",
      titleMsg3: "病害虫管理",
      dalResultVisible: false,
    };
  },
  methods: {
    resultOnclick: function () {
      this.dalResultVisible = true;
    },
  },
};
</script>

<style>
.dal-card {
  margin-left: 18px;
 margin-top: -8.5%;
  width: 97%;
}  .ant-list-item-meta{
     margin-bottom: 10px;
   }
</style>


